export const styles = {
  container: {
    label: 'PrivacySummaryOverlay',
    zIndex: 7
  },
  modal: {
    position: 'relative',
    alignItems: 'flex-start'
  },
  closeButton: {
    position: 'absolute',
    right: 20,
    top: 24,
    cursor: 'pointer'
  },
  headingTwo: {
    fontSize: 5,
    fontWeight: '600',
    mb: 4
  },
  privacyPolicyLink: {
    textDecoration: 'underline',
    color: 'currentColor'
  }
}
export default styles
